import { Box } from '@vk-hr-tek/ui/Box';
import { Link } from '@vk-hr-tek/ui/Link';

import { useIsWidget } from '@app/hooks';

import { Logo } from '../../Logo';

interface MobileMenuLogoProps {
  onMenuItemClick(pageTitle: string): void;
}

export const MobileMenuLogo = ({ onMenuItemClick }: MobileMenuLogoProps) => {
  const isWidget = useIsWidget();

  const urlWithPrefix = (url: string) => {
    if (isWidget) {
      return `${window.REACT_APP_VKHRTEK_WIDGET_STATIC_URL}${url}`;
    }
    return url;
  };

  return (
    <Box display="flex" alignItems="center" className="aqa_mobileMenuLogo">
      <Link
        {...(isWidget ? { href: urlWithPrefix('/') } : { to: '/' })}
        onClick={() => onMenuItemClick('Главная')}
      >
        <Logo variant="24" />
      </Link>
    </Box>
  );
};

MobileMenuLogo.displayName = 'MobileMenuLogo';
